import { useCallback } from 'react';

import { useToasts } from 'dibs-toaster/exports/useToasts';

import { AddToFolderToastContent, RemoveFromFolderToastContent } from './FolderToastsContent';
import { SHARED_TOAST_PROPS } from './sharedToastProps';
import { isItemFavoritingVariant } from './abTests';
import { trackItemFavoritingToast } from './tracking';

const useFolderToasts = (): {
    addToFolderToast: (portfolio: { portfolioId: string; portfolioName: string }) => void;
    removeFromFolderToast: (portfolio: { portfolioName: string }) => void;
} => {
    const { addToast } = useToasts();

    const addToFolderToast = useCallback(
        ({ portfolioId, portfolioName }: { portfolioId: string; portfolioName: string }) => {
            if (!isItemFavoritingVariant()) {
                return;
            }

            addToast({
                toast: {
                    ...SHARED_TOAST_PROPS,
                    children: (
                        <AddToFolderToastContent
                            portfolioId={portfolioId}
                            portfolioName={portfolioName}
                        />
                    ),
                },
            });
            trackItemFavoritingToast({ trigger: 'foldered' });
        },
        [addToast]
    );

    const removeFromFolderToast = useCallback(
        ({ portfolioName }: { portfolioName: string }) => {
            if (!isItemFavoritingVariant()) {
                return;
            }

            addToast({
                toast: {
                    ...SHARED_TOAST_PROPS,
                    children: <RemoveFromFolderToastContent portfolioName={portfolioName} />,
                },
            });
            trackItemFavoritingToast({ trigger: 'folder removed' });
        },
        [addToast]
    );

    return {
        addToFolderToast,
        removeFromFolderToast,
    };
};

export { useFolderToasts };
